import { documentPackageResultSchema, getDocumentPackageResultsResponseSchema, } from '@consigli/types';
import { createTransformer, createParams, mapToSnakeCase, } from './shared/base-api';
export const documentPackageResultApiEndpoints = (builder, coreApiBaseUrl) => ({
    getDocumentPackageResults: builder.query({
        query: ({ projectId, documentPackageId, page, pageSize, search, processor, type }) => {
            const params = createParams({ page, pageSize, search, processor, type });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/results/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['DocumentPackageResults'],
        transformResponse: createTransformer(getDocumentPackageResultsResponseSchema, 'getDocumentPackageResults'),
    }),
    getDocumentPackageResult: builder.query({
        query: ({ projectId, documentPackageId, resultId }) => `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/results/${resultId}/`,
        providesTags: ['DocumentPackageResults'],
        transformResponse: createTransformer(documentPackageResultSchema, 'getDocumentPackageResult'),
    }),
    createDocumentPackageResult: builder.mutation({
        query: ({ projectId, documentPackageId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/results/`,
            method: 'POST',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: ['DocumentPackageResults'],
        transformResponse: createTransformer(documentPackageResultSchema, 'createDocumentPackageResult'),
    }),
    updateDocumentPackageResult: builder.mutation({
        query: ({ projectId, documentPackageId, resultId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/results/${resultId}/`,
            method: 'PATCH',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: ['DocumentPackageResults'],
        transformResponse: createTransformer(documentPackageResultSchema, 'updateDocumentPackageResult'),
    }),
    deleteDocumentPackageResult: builder.mutation({
        query: ({ projectId, documentPackageId, resultId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/results/${resultId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['DocumentPackageResults'],
    }),
});
